import DashboardIncidentsMainSeverity from './DashboardIncidentsMainSeverity';

export default DashboardIncidentsMainSeverity;
